import {Component, OnInit, Input, AfterViewInit} from '@angular/core';
import { DatePipe } from '@angular/common';
import { chartConfig } from '../../../../app.constants';
import { MentionTimeLineReportItem } from '../../../../../models/chart';
import {TranslateService} from '@ngx-translate/core';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';

enum MentionType {
  Keyword = 'Keyword',
  Url = 'Url',
  Hashtag = 'Hashtag',
}

enum SeriesColorsIndex {
  Hashtag = 5,
  Url = 6,
  Keyword = 7,
}

@Component({
  selector: 'mention-timeline-report',
  templateUrl: './mention-timeline-report.component.html',
  styleUrls: ['./mention-timeline-report.component.scss']
})
export class MentionTimelineReportComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'MentionTimelineReportComponent';
  @Input() data: Array<MentionTimeLineReportItem>;
  public chartData: Array<any> = [];
  public isNoData: boolean;
  constructor(private datePipe: DatePipe,
              private translate: TranslateService,
              private pdfService: PdfExportService,
              private userService: UserService) { }

  ngOnInit() {
    this.isNoData = false;
    if (this.data.length === 0) {
      this.isNoData = true;
      return;
    }

    const keyword = {
      name: this.translate.instant('measure.mention_keywords'),
      data: [],
      color: this.userService.chartColors[SeriesColorsIndex.Keyword]
    };

    const urls = {
      name: this.translate.instant('measure.mention_urls'),
      data: [],
      color: this.userService.chartColors[SeriesColorsIndex.Url]
    };

    const hashTags = {
      name: this.translate.instant('measure.mention_hashtag'),
      data: [],
      borderRadiusTopLeft: 15,
      borderRadiusTopRight: 15,
      color: this.userService.chartColors[SeriesColorsIndex.Hashtag]
    };

    keyword.data = this.data
      .filter( item => item.keyword_type === MentionType.Keyword)
      .map( item => [
        this.datePipe.transform(item.date, 'd MMM'),
        item.appear
      ]);

    urls.data = this.data
      .filter( item => item.keyword_type === MentionType.Url)
      .map( item => [
        this.datePipe.transform(item.date, 'd MMM'),
        item.appear
      ]);

      hashTags.data = this.data
      .filter( item => item.keyword_type === MentionType.Hashtag)
      .map( item => [
        this.datePipe.transform(item.date, 'd MMM'),
        item.appear
      ]);

    this.chartData.push(hashTags, urls, keyword);

  }
  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(MentionTimelineReportComponent.COMPONENT_NAME);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/mention-timeline-report/mention-timeline-report.component.ts